import { DestroyManyOptions } from 'api/administration/monitoring/DestroyMany'
import { createAction } from 'helpers/redux-actions.helper'
import { ActionsUnion } from 'helpers/types.helper'
import { IMonitoringModel } from 'models/monitoring.model'
import { ISelectedItems } from 'store/states/monitoring.state'

export const MONITORING_GET_SUCCESS = 'MONITORING_GET_SUCCESS'
export const MONITORING_SET_LOADING = 'MONITORING_SET_LOADING'
export const USER_MONITORING_GET = 'USER_MONITORING_GET'
export const USER_MONITORING_GET_SUCCESS = 'USER_MONITORING_GET_SUCCESS'
export const USER_MONITORING_DESTROY_MANY = 'USER_MONITORING_DESTROY_MANY'
export const USER_MONITORING_DESTROY_MANY_SUCCESS =
  'USER_MONITORING_DESTROY_MANY_SUCCESS'
export const USER_MONITORING_UPLOAD = 'USER_MONITORING_UPLOAD'
export const USER_MONITORING_UPLOAD_SUCCESS = 'USER_MONITORING_UPLOAD_SUCCESS'
export const UPDATE_SELECTED_ITEMS = 'UPDATE_SELECTED_ITEMS'
export const SEND_EMAIL = 'SEND_EMAIL'

export interface UploadFilePayload {
  id: number
  file: File
  onSuccess?: () => void
}

export type DestroyPayload = DestroyManyOptions

export const Actions = {
  monitoringGetSuccess: (
    data: IMonitoringModel[],
    total: number,
    perPage: number,
    sort: any[]
  ) => createAction(MONITORING_GET_SUCCESS, { data, total, perPage, sort }),
  userMonitoringGet: ({ courseId, UserId }: any) =>
    createAction(USER_MONITORING_GET, { courseId, UserId }),
  userMonitoringGetSuccess: (data: IMonitoringModel[]) =>
    createAction(USER_MONITORING_GET_SUCCESS, data),
  updateSelectedItems: (selectedItems: ISelectedItems) =>
    createAction(UPDATE_SELECTED_ITEMS, selectedItems),
  destroyMany: (payload: DestroyPayload) =>
    createAction(USER_MONITORING_DESTROY_MANY, payload),
  destroyManySuccess: (data: any) =>
    createAction(USER_MONITORING_DESTROY_MANY_SUCCESS, data),
  uploadFile: ({ id, file }: UploadFilePayload) =>
    createAction(USER_MONITORING_UPLOAD, { id, file }),
  uploadFileSuccess: (data: any) =>
    createAction(USER_MONITORING_UPLOAD_SUCCESS, data),
  setLoading: (data: boolean) => createAction(MONITORING_SET_LOADING, data),
}

export type Actions = ActionsUnion<typeof Actions>
